var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWf07W(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 16,
    height: 21,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Framesolutons-1",
    transform: "translate(17 14)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M10.014,6.3V.029C9.819.017,9.674,0,9.53,0Q5.362,0,1.194,0C.325,0,.011.323.011,1.219.009,7.408.016,13.6,0,19.785A1.371,1.371,0,0,0,.607,21H16V6.3ZM5.048,2.1a2.1,2.1,0,0,1-.06,4.2,2.1,2.1,0,0,1,.06-4.2Zm-.1,5.25A3,3,0,0,1,7.97,10.475H2.056A2.975,2.975,0,0,1,4.946,7.35ZM9.869,18.9c-1.13.007-2.261,0-3.392,0s-2.194,0-3.292,0c-.755,0-1.171-.378-1.177-1.041S2.421,16.8,3.165,16.8q3.342-.008,6.684,0c.742,0,1.162.4,1.153,1.065A1,1,0,0,1,9.869,18.9Zm3.17-4.207c-.431.031-.865.009-1.3.009q-4.268,0-8.535,0a1.057,1.057,0,1,1-.114-2.1c1.646-.013,3.294,0,4.94,0h4.842a1,1,0,0,1,1.006.54,1.046,1.046,0,0,1-.842,1.556Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M16,4.093V4.2H12.033V.064c.13.116.238.2.334.3C13.451,1.5,14.533,2.644,15.62,3.779A3.941,3.941,0,0,0,16,4.093Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWf07W);
export default __webpack_public_path__ + "static/media/icon-wf-07-w.b9e6fecf21cd1bd68481e2d73cc967c5.svg";
export { ForwardRef as ReactComponent };